<div class="registred-footer-section">
  <a [routerLink]="['/']">
  <img src="/assets/icons/new_reg_logo.png"/>
  </a>
  <div class="footer-right-sec">
    <div class="d-flex">
    <label class="justify-content-right">©2021 Boys & Girls Clubs of America</label>
  </div>
    <div>
      <ul>
        <li>
          <a [routerLink]="['/termsofuse']"> Terms of Use</a>
        </li>
        <li>
          <a [routerLink]="['/legalpolicy']"> Legal Notice & Privacy Policy</a>
        </li>
        <li>
          <a [routerLink]="['/faq']"> Help Guides</a>
        </li>
      </ul>
    </div>
    <div class="footer-icons">
      <!-- <a href="#" target="">
        <fa-icon [icon]="['fab','twitter']"></fa-icon>
      </a>
      <a href="#" target="">
        <fa-icon [icon]="['fab','instagram']"></fa-icon>
      </a>
      <a href="#" target="">
        <fa-icon [icon]="['fab','youtube']"></fa-icon>
      </a> -->
    </div>
  </div>
</div>